import { PILL_COLORS } from "components/ui/Pill";

/*
 * A DEASP certificate's status is a *submission* status, not a document one: it says how far the
 * cert got through Healthlink and DEASP, not whether anyone in the practice has reviewed it.
 *
 * It lives here rather than in either table because two of them show it — the DEASP section and
 * the merged "All Documents" list (KIN-2102) — and a cert shown as "Claim Approved" in one place
 * and "CERT_ACCEPTED" in the other reads as two different things.
 */

export const DEASP_CERTIFICATE_STATUS_LABELS = {
  PENDING: "Pending",
  SENT: "Sent to Healthlink",
  ERROR: "Rejected by Healthlink",
  DEASP_RECEIVED: "Accepted by DEASP",
  DEASP_ERROR: "Rejected by DEASP",
  CERT_ACCEPTED: "Claim Approved",
  CERT_REJECTED: "Claim Rejected",
};

export const DEASP_CERTIFICATE_STATUS_COLORS = {
  PENDING: PILL_COLORS.statusPending,
  SENT: PILL_COLORS.statusSent,
  ERROR: PILL_COLORS.statusError,
  DEASP_RECEIVED: PILL_COLORS.statusAcknowledged,
  DEASP_ERROR: PILL_COLORS.statusError,
  CERT_ACCEPTED: PILL_COLORS.statusSuccess,
  CERT_REJECTED: PILL_COLORS.statusError,
};

/*
 * An unmapped status is shown as the backend sent it rather than as "Unknown": a status we have no
 * label for is still a fact about the submission, and hiding it behind "Unknown" would lose it.
 */
export const getDeaspCertificateStatusDisplay = (status) => {
  if (!status) return null;

  return {
    label: DEASP_CERTIFICATE_STATUS_LABELS[status] ?? status,
    colors:
      DEASP_CERTIFICATE_STATUS_COLORS[status] ?? PILL_COLORS.reactionUnknown,
  };
};
